<template>
  <MyCaseHeader
    class="rejoin-header"
    title="Rejoin today!"
    variant="orchid">
    <p>
      You previously selected the <b>{{ latestPlan.displayName }} for ${{ price }}/month.</b>
    </p>
    <BaseButton
      text="Continue"
      class="mb-2"
      :class="{ 'w-100': isMobile }"
      variant="secondary"
      @click="beginRejoinFlow"/>
  </MyCaseHeader>
</template>

<script setup>
import { useRejoinStore } from '@/stores/rejoin.js'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import MyCaseHeader from '@/components/case/common/header/MyCaseHeader.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import useScreenSize from '@shared/composables/screenSize'

const { isMobile } = useScreenSize()
const { latestPlan } = storeToRefs(useRejoinStore())

const price = computed(() => {
  return latestPlan.value.basePrice / 100
})

const { beginRejoinFlow } = useRejoinStore()

</script>
<style lang="scss" scoped>
.rejoin-header {
  :deep(.title) {
    color: white !important;
    font-size: 20px !important;
    font-weight: 600 !important;
  }
}
</style>
